import sessionReplay from './session-replay-factory';
export const { init, setSessionId, getSessionReplayProperties, flush, shutdown } = sessionReplay;
